import React from "react";
import { observer } from "mobx-react";
import { VatStatusUpdateStore } from "../../store";
import { VatStatusUpdateForm } from "./VatStatusUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type VatStatusUpdateProps = {
  vatStatusUpdateStore: VatStatusUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const VatStatusUpdate: React.FC<VatStatusUpdateProps> = observer(
  ({ vatStatusUpdateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={vatStatusUpdateStore.isSaving} />
        <OutdatedAfterSaveNotice
          open={vatStatusUpdateStore.savedButOutdated}
          onReload={() => vatStatusUpdateStore.reloadVatStatus()}
          reloadDisabled={vatStatusUpdateStore.isProcessing}
        />
        <VatStatusUpdateForm
          vatStatusUpdateStore={vatStatusUpdateStore}
          name_esError={vatStatusUpdateStore.errors.name_es?.message}
          onName_esChange={(value: string) => {
            vatStatusUpdateStore.setName_esValue(value);
          }}
          name_es={vatStatusUpdateStore.entityValues.name_es}
          name_enError={vatStatusUpdateStore.errors.name_en?.message}
          onName_enChange={(value: string) => {
            vatStatusUpdateStore.setName_enValue(value);
          }}
          name_en={vatStatusUpdateStore.entityValues.name_en}
          name_ptError={vatStatusUpdateStore.errors.name_pt?.message}
          onName_ptChange={(value: string) => {
            vatStatusUpdateStore.setName_ptValue(value);
          }}
          name_pt={vatStatusUpdateStore.entityValues.name_pt}
          description_esError={
            vatStatusUpdateStore.errors.description_es?.message
          }
          onDescription_esChange={(value: string) => {
            vatStatusUpdateStore.setDescription_esValue(value);
          }}
          description_es={vatStatusUpdateStore.entityValues.description_es}
          description_enError={
            vatStatusUpdateStore.errors.description_en?.message
          }
          onDescription_enChange={(value: string) => {
            vatStatusUpdateStore.setDescription_enValue(value);
          }}
          description_en={vatStatusUpdateStore.entityValues.description_en}
          description_ptError={
            vatStatusUpdateStore.errors.description_pt?.message
          }
          onDescription_ptChange={(value: string) => {
            vatStatusUpdateStore.setDescription_ptValue(value);
          }}
          description_pt={vatStatusUpdateStore.entityValues.description_pt}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={vatStatusUpdateStore.saveDisabled}
          onSave={() => vatStatusUpdateStore.saveVatStatus()}
          onCancel={() => vatStatusUpdateStore.cancelVatStatus()}
        />
        <ErrorDialog
          open={vatStatusUpdateStore.errorDialogOpened}
          title={vatStatusUpdateStore.errorTitle}
          description={vatStatusUpdateStore.errorDescription}
          onClose={() => vatStatusUpdateStore.closeErrorDialog()}
        />
        <ConfirmCancelDialog
          open={vatStatusUpdateStore.confirmDialogOpened}
          title={vatStatusUpdateStore.confirmDialogTitle}
          description={vatStatusUpdateStore.confirmDialogDescription}
          onConfirm={() => vatStatusUpdateStore.executeConfirmedAction()}
          onCancel={() => vatStatusUpdateStore.closeConfirmDialog()}
        />
      </>
    );
  }
);
